import { Component, Input } from '@angular/core';
import { Benefits } from '../../models/benefits.interfaces';

@Component({
  selector: 'idp-goodies',
  templateUrl: './goodies.component.html',
  styleUrls: ['./goodies.component.scss']
})
export class GoodiesComponent {
  @Input() content: Benefits = {} as Benefits;
  @Input() index = 0;
}
